var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 31 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.774 20H5.772C3.096 20 .939 17.633.939 14.722V5.278C.94 2.355 3.106 0 5.772 0h20.002c2.676 0 4.832 2.367 4.832 5.278v9.444C30.616 17.645 28.45 20 25.774 20Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.02 9.852 12.607 5v9.704l8.415-4.852Z",
    fill: "#fff"
  })));
};
export default SvgYoutube;